export default {
    title: 'Weekly Calendar',
    subtitle: 'View scheduled container arrivals by week',
    currentWeek: 'Current Week',
    week: 'Week',
    weekNumber: 'Week {{number}}',
    noContainers: 'No containers scheduled for this week',
    containers: 'Containers',
    origins: 'Origins',
    senders: 'Senders',
    totalValue: 'Total Value',
    commodities: 'Commodities',
    expandDetails: 'View Details',
    collapseDetails: 'Hide Details',
    containerCount: '{{count}} container',
    containerCount_plural: '{{count}} containers',
    originCount: '{{count}} origin',
    originCount_plural: '{{count}} origins',
    senderCount: '{{count}} sender',
    senderCount_plural: '{{count}} senders',
    weekRange: '{{startDate}} - {{endDate}}',
    loading: 'Loading calendar...',
    error: 'Error loading calendar data',
    retry: 'Retry',
    // Target and goals
    targetReached: 'Target Reached',
    targetPending: 'Target Pending',
    containerTarget: 'Container Target',
    revenueTarget: 'Revenue Target',
    editTarget: 'Edit Target',
    confirmed: 'confirmed',
    pending: 'pending',
    // Trend Cards
    trendCards: {
        yearlyContainers: 'Yearly Containers',
        yearlyRevenue: 'Yearly Revenue',
        monthlyContainers: 'Monthly Containers',
        monthlyRevenue: 'Monthly Revenue',
    },
    // Chart
    chart: {
        titleContainers: 'Container Distribution by Week',
        titleRevenue: 'Revenue Distribution by Week',
        yAxisContainers: 'Number of Containers',
        yAxisRevenue: 'Revenue (USD)',
        target: 'Target',
        confirmed: 'Confirmed',
        pending: 'Pending',
        total: 'Total',
    },
    // View toggle
    viewContainers: 'View Containers',
    viewRevenue: 'View Revenue',
    // Target Modal
    targetModal: {
        title: 'Edit Target Week {{week}}',
        containerTarget: 'Container Target',
        revenueTarget: 'Revenue Target (USD)',
        useDefault: 'Use default weekly target',
        resetToDefault: 'Reset to Default Target',
    },
    // Footer
    viewingWeeks: 'Viewing {{count}} weeks for year {{year}}',
    noContainersForYear: 'No containers for {{year}}',
    noContainersMessage: 'There are no containers scheduled for this year.',
    // View Mode
    viewMode: {
        carousel: 'Carousel',
        list: 'List',
    },
    // Carousel
    carousel: {
        previous: 'Previous',
        next: 'Next',
        weekOf: 'Week {{current}} of {{total}}',
        jumpToCurrent: 'Jump to Current',
        noWeekData: 'No data available',
    },
    // List View
    listView: {
        week: 'Week',
        containerTarget: 'Container Target',
        revenueTarget: 'Revenue Target',
        containers: 'Containers',
        value: 'Value',
        actions: 'Actions',
        expand: 'Expand',
        collapse: 'Collapse',
        containersDetails: 'Container Details ({{count}})',
        containerNumber: 'Container Number',
        route: 'Route',
        eta: 'ETA',
        status: 'Status',
        confirmation: 'Confirmation',
    },
};
